/* eslint-disable camelcase */
import { useState, useEffect } from 'preact/hooks'
import { Provider } from 'react-redux'
import { get } from 'lodash'
import { init } from '@advisiondevelopment/websockets'

import configureStore from 'store/configureStore'
import 'assets/styles/index.css'

const DEV_ENV = 'development'
const DEFAULT_WIDGET = 'homepage-scoreboard'
const PICKS_WIDGET = 'picks-widget'
const KEY_GAMES_WIDGET = 'key-games-widget'
const ODDS_WIDGET = 'odds-widget'
const HUB_ODDS_WIDGET = 'hub-odds-widget'
const HOMEPAGE_SCOREBOARD = 'homepage-scoreboard'
const ODDS_GRID = 'odds-grid'
const FUTURES_GRID = 'futures-grid'

const widgets = {
  [DEFAULT_WIDGET]: () =>
    import(
      /* webpackChunkName:"HomepageScoreBoard" */ 'containers/HomepageScoreBoard/HomepageScoreBoard'
    ),
  [PICKS_WIDGET]: () =>
    import(
      /* webpackChunkName:"PicksWidget" */ 'containers/PicksWidget/PicksWidget'
    ),
  [KEY_GAMES_WIDGET]: () =>
    import(
      /* webpackChunkName:"KeyGamesWidget" */ 'containers/KeyGamesWidget/KeyGamesWidget'
    ),
  [ODDS_WIDGET]: () =>
    import(
      /* webpackChunkName:"OddsWidget" */ 'containers/OddsWidget/OddsWidget'
    ),
  [HUB_ODDS_WIDGET]: () =>
    import(
      /* webpackChunkName:"HubPagesOddsWidget" */ 'containers/HubPagesOddsWidget/HubPagesOddsWidget'
    ),
  [HOMEPAGE_SCOREBOARD]: () =>
    import(
      /* webpackChunkName:"HomepageScoreBoard" */ 'containers/HomepageScoreBoard/HomepageScoreBoard'
    ),
  [ODDS_GRID]: () =>
    import(
      /* webpackChunkName:"OddsGridWidget" */ 'containers/OddsGridWidget/OddsGridWidget'
    ),
  [FUTURES_GRID]: () =>
    import(
      /* webpackChunkName:"FuturesGridWidget" */ 'containers/FuturesGridWidget/FuturesGridWidget'
    ),
}

const getStore = (env) => {
  const store = configureStore(env)

  window.__STORE__ = store

  return store
}

const widgetSwitcher = async (config, environment) => {
  if (process.env.NODE_ENV !== DEV_ENV) {
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = environment.widgetDomain
  }

  const widgetFromConfig = get(config, 'widget')
  const module = await widgets[widgetFromConfig]()
  const Component = module.default

  return <Component config={config} environment={environment} />
}

const App = ({ config, environment }) => {
  const [component, setComponent] = useState(null)

  init({
    liveOddsUri: environment.liveOdds,
    maxTimeForReconnect: environment.maxTimeForReconnect,
  })

  useEffect(() => {
    widgetSwitcher(config, environment).then((comp) => setComponent(comp))
  }, [])

  return <Provider store={getStore(environment)}>{component}</Provider>
}

export default App
